import type { KycState } from '../../types'
import { deriveKycStep, type KycStep, type KycStepState } from './kycStep'
import { SAMPLE_FAILED_DOCS } from './sampleKycStep'

/**
 * ⚠️ DEV OVERRIDE — force a KYC step to demo it, or `null` to use the live state.
 *
 * Set it to a KycStepState and `/apply` renders that case regardless of what the
 * BFF returned — the live `kyc` is not consulted at all, so any case is
 * presentable without a matching server-side situation. Forcing `'failed'` uses
 * SAMPLE_FAILED_DOCS for the dialog's contents.
 *
 * Never ships: the guard below is `import.meta.env.DEV && DEV_KYC_STEP_OVERRIDE`,
 * which is statically false in a production build, so this can't leak into prod
 * even if it's left set. Mirrors DEV_STATUS_OVERRIDE in hooks/useCurrentUser.
 */
const DEV_KYC_STEP_OVERRIDE: KycStepState | null = null

/** The step to render for the caller, honouring the dev override above. */
export function useKycStep(kyc?: KycState): KycStep {
  if (import.meta.env.DEV && DEV_KYC_STEP_OVERRIDE) {
    return {
      state: DEV_KYC_STEP_OVERRIDE,
      failedDocs: DEV_KYC_STEP_OVERRIDE === 'failed' ? SAMPLE_FAILED_DOCS : [],
    }
  }
  return deriveKycStep(kyc)
}
